import React, { useState, useEffect } from 'react';
import Search from '../Search';
import SearchBox from './SearchBox';
import SearchResults from './SearchResults';
import {
    getUserGeoData,
    filterGEOProductSKUs
} from '../../../tools/utilities';
import { ga4TrackingEcommerce } from '../../../modules/tracking';

const SearchOverlay = ({}) => {
    const postsPerPage = 4;
    const page = 1;
    const [isActive, setIsActive] = useState(false);
    const [type, setType] = useState(['post']);
    const [location, setLocation] = useState(null);
    const [tabType, setTabType] = useState('post');
    const [tax, setTax] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [hasTyped, setHasTyped] = useState(false);
    const [totalResults, setTotalResults] = useState(0);
    const [results, setResults] = useState(null);
    const [loadingGEO, setLoadingGEO] = useState(true);
    const [country, setCountry] = useState('GB');
    const [currency, setCurrency] = useState('GBP');
    const [userGeoData, setUserGeoData] = useState({
        country: 'GB',
        currency: 'GBP',
        locale: 'en-GB',
    });
    const [sendViewItem, setSendViewItem] = useState(true);

    const fetchUserGeoData = async () => {
        const userGeoData = await getUserGeoData();
        setUserGeoData(userGeoData);
        setCurrency(userGeoData.currency);
        setCountry(userGeoData.country);
        setLoadingGEO(false);
    };

    const handleSetType = data => {

        if (data.post_type) {
            setType(data.post_type);
        }
        
        if (data.category) {
            setTax(data.category);
        } else {
            setTax('');
        }
    };

    const handleOnBlur = () => {

        setTimeout(() => {

            if(!searchTerm) {
                setIsActive(false);
            }

        }, 100);

    };

    const handleTabChange = type => {
        
        if(type) {
            
            setTabType(type);

            switch(type) {
                case 'product':
                    setLocation('Products');
                    break;
                case 'podcast':
                    setLocation('Podcasts');
                    break;
                case 'video':
                    setLocation('Videos');
                case 'database':
                        setLocation('Database');
                default:
                    setLocation('Articles');
              }

        }

    }

    const handleSetTerm = term => {
        setSearchTerm(term);
        setHasTyped(true);
    };

    const handleOnFocus = () => {
        setIsActive(true);
    };

    const handleHasTyped = () => {
        setHasTyped(true);
    };

    const handleCloseOverlay = () => {
        setIsActive(false);
        setSearchTerm('');
        setHasTyped(false);
        setResults(null);
    }

    const doSearch = async () => {

        if (!searchTerm && searchTerm.length < 3) {
            return;
        }

        const search = new Search(searchTerm, tax, type, postsPerPage, page);

        const { responses } = await search.getResults();

        if (responses) {
            const totalResultCount = responses.reduce((prev, next, index) => {
                if (
                    index === 0 || index === 6
                ) {
                    return prev;
                }
                return prev + next.hits.total.value;
            }, 0);

            setTotalResults(totalResultCount);
            
            let returnedResults = {
                results: responses[0].hits,
                totalResultCount,
                Products: responses[1].hits.total.value,
                Articles: responses[2].hits.total.value,
                Videos: responses[3].hits.total.value,
                Podcasts: responses[4].hits.total.value,
                Database: responses[5].hits.total.value,
                type,
            };

            setResults(returnedResults);
        }
    };

    useEffect(() => {
        fetchUserGeoData();

        const host = window.location.host;
        const location = window.location.href;
        const tax = document.querySelector('input[name="search_type"]');

        if(tax) {
            const value = tax.value;

            if(value) {
                switch(value) {
                    case 'product':
                        setLocation('Products');
                        setType(['product']);
                        setTabType('product');
                        break;
                    case 'podcast':
                        setLocation('Podcasts');
                        setType(['post']);
                        setTax('podcast');
                        setTabType('podcast');
                        break;
                    case 'video':
                        setLocation('Videos');
                        setType(['post']);
                        setTax('video');
                        setTabType('video');
                        break;
                    case 'database':
                        setLocation('Database');
                        setType(['database']);
                        setTabType('database');
                        break;
                    default:
                        setLocation('Articles');
                }
            }
        }

        if(location.includes(host + '/database') ) {
            setLocation('Database');
            setType(['database']);
            setTabType('database');
        }
        
    }, []);
    
    useEffect(() => {
        
        if(searchTerm) {
            setTimeout(() => {
                setIsActive(true);
            }, 101);
        }
        
    }, [searchTerm]);

    useEffect(() => {
        if (!loadingGEO) {
            setSendViewItem(true);
            doSearch();
        }
    }, [loadingGEO, searchTerm, tax, type]);

    useEffect(() => {
        if (sendViewItem && totalResults > 0 && results !== null) {
            const items = Object.values(results?.results?.hits)
                .filter(result => result._source.postType === 'product')
                .map(result => {
                    let selectedSku = null;
                    const skus = filterGEOProductSKUs(result._source.skus, currency, country);
                    if (skus.length > 0) {
                        const firstKey = Object.keys(skus)[0];
                        selectedSku = skus[firstKey];
                    }

                    return selectedSku;
                })
                .filter(result => result !== null);
            if (items.length > 0) {
                ga4TrackingEcommerce('view_item', items);
                setSendViewItem(false);
            }
        }
    }, [sendViewItem, results, totalResults]);

    return (
        <>
            <SearchBox
                term={searchTerm}
                type={type}
                tax={tax}
                handleSetTerm={handleSetTerm}
                handleOnFocus={handleOnFocus}
                handleHasTyped={handleHasTyped}
                handleCloseOverlay={handleCloseOverlay}
                handleOnBlur={handleOnBlur}
            />

            {isActive ? (
                <section className="search-overlay">
                    <div className="search-overlay__content">
                        <SearchResults
                            term={searchTerm}
                            type={type}
                            tabType={tabType}
                            location={location}
                            totalResults={totalResults}
                            results={results}
                            hasTyped={hasTyped}
                            handleSetType={handleSetType}
                            handleSetTerm={handleSetTerm}
                            handleHasTyped={handleHasTyped}
                            handleTabChange={handleTabChange}
                            handleCloseOverlay={handleCloseOverlay}
                            country={country}
                            currency={currency}
                            userGeoData={userGeoData}
                        />
                    </div>
                </section>
            ) : (
                ''
            )}
        </>
    );
};

export default SearchOverlay;
